import { useEffect, useState } from 'react';
import { attachPendo } from './attach-pendo';
import { PendoWindow } from './types';

declare let window: PendoWindow;

/**
 * Attaches pendo to the head of the dom as a script element.
 *
 * @param apiKey The pendo application key to use for loading pendo.
 * @returns The script element pendo is loaded to or null if it is not loaded.
 */
export const useAttachPendo = (apiKey?: string): HTMLScriptElement | null => {
  const [scriptEl, setScriptEl] = useState<HTMLScriptElement | null>(null);

  useEffect(() => {
    let cleanupFn = (): void => undefined;

    if(apiKey) {
      const pendoScriptEl = attachPendo(apiKey);

      setScriptEl(pendoScriptEl);

      if (pendoScriptEl) {
        cleanupFn = (): void => {
          pendoScriptEl.remove();
          delete window.pendo;
        };
      }
    }

    return cleanupFn;
  }, [apiKey]);

  return scriptEl;
}

/**
 * @returns Pendo from the window if it exists.
 */
export const usePendoFromWindow = (): PendoWindow['pendo'] | null => {
  const [pendo, setPendo] = useState(window.pendo);

  useEffect(() => {
    setPendo(window.pendo);
  }, [window.pendo]);

  return pendo;
}
